
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { FormatDateMixin } from '@returns-centre/mixins';
import _ from 'lodash';
import { store, ShopModule, TradeInModule, CustomerModule } from '@returns-centre/store';
import { getModule } from 'vuex-module-decorators';
import { ValidationErrors } from '@returns-centre/components';

import { TradeInItemProductList, TradeInReturnTrackingView } from '@returns-centre/components';

import { VTooltip, VPopover, VClosePopover } from 'v-tooltip';

Vue.directive('tooltip', VTooltip);
Vue.directive('close-popover', VClosePopover);
Vue.component('v-popover', VPopover);

@Component({
    components: {
        ValidationErrors,
        TradeInItemProductList,
        TradeInReturnTrackingView,
    },
    filters: {
        startCase(val: string): string {
            return val.replace(/\w+/g, _.capitalize);
        },
    },
})
export default class TradeInDetails extends mixins(FormatDateMixin) {
    tradeInModule = getModule(TradeInModule, store);
    shopModule = getModule(ShopModule, store);
    customerModule = getModule(CustomerModule, store);

    tradeIn: TradeIn | null = null;

    async created() {
        if (!this.$route.params.id) {
            return;
        }
        await this.customerModule.fetchTradeIn(parseInt(this.$route.params.id)).then((r) => {
            this.tradeIn = this.customerModule.trade_in;
        });
    }

    downloadShippingLabel(labelUrl: string) {
        window.open(labelUrl);
    }

    getTradeInItemsCount(tradeInItems: TradeInItem[]): number {
        let count: number = 0;
        for (const item of tradeInItems) {
            let qtyRange = _.range(item.quantity);
            count = count + qtyRange.length;
        }
        return count;
    }
}
